import { Controller } from "@hotwired/stimulus"

// Turbo disables the submitter while pending. Restore keyboard focus after its
// region is morphed, without moving the page or overriding pointer navigation.
export default class extends Controller {
  static targets = ["submitter"]

  remember(event) {
    this.restoreSubmitter = this.hasSubmitterTarget &&
      event.submitter === this.submitterTarget && document.activeElement === event.submitter
  }

  restore() {
    if (this.restoreSubmitter && this.hasSubmitterTarget) {
      this.submitterTarget.focus({ preventScroll: true })
    }
    this.restoreSubmitter = false
  }

  disconnect() {
    this.restoreSubmitter = false
  }
}
